<template>
  <footer class="contact">
    <div class="contact-grid">
      <div class="contact-info">
        <h3>Contact</h3>
        <p class="contact-link">
          <a
            href="https://www.google.com/maps/place/Auto+Heaven/@45.8324386,21.2803961,17z"
            target="_blank"
          >
            <i class="fas fa-map-marker-alt"></i>
            Auto Heaven Giarmata, România
          </a>
        </p>

        <p class="contact-link">
          <a href="tel:+40773383914">
            <i class="fas fa-phone-alt"></i>
            0773 383 914
          </a>
        </p>

        <p class="contact-link">
          <a href="mailto:autoheaven.ro@gmail.com" target="_blank">
            <i class="fas fa-envelope"></i>
            autoheaven.ro@gmail.com
          </a>
        </p>
      </div>

      <div class="legal-links">
        <h3>Legal</h3>
        <ul>
          <li>
            <router-link to="/politica-confidentialitate"
              >Confidențialitate</router-link
            >
          </li>
          <li><router-link to="/politica-cookie">Cookies</router-link></li>
          <li><router-link to="/anpc">ANPC</router-link></li>
        </ul>
      </div>

      <div class="social-icons">
        <h3>Urmărește-ne</h3>
        <a href="https://instagram.com/autoheaven.ro" target="_blank"
          ><i class="fab fa-instagram"></i
        ></a>
        <a href="https://tiktok.com/@autoheaven.ro" target="_blank"
          ><i class="fab fa-tiktok"></i
        ></a>
        <a
          href="https://www.facebook.com/profile.php?id=61554863440673"
          target="_blank"
          ><i class="fab fa-facebook-f"></i
        ></a>
        <a href="https://wa.me/40773383914" target="_blank"
          ><i class="fab fa-whatsapp"></i
        ></a>
      </div>
    </div>

    <div class="copyright-bar">
      © 2025 Auto Heaven. Toate drepturile rezervate.
    </div>
    <div class="site-author">
      Website realizat de
      <a href="https://www.instagram.com/cola_alin" target="_blank">CAC</a>
    </div>
  </footer>
</template>

<style scoped>
.contact {
  color: white;
  padding: 2rem;
  background: black;
  font-family: Arial, sans-serif;
}

.contact-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.contact-info,
.legal-links,
.social-icons {
  flex: 1 1 250px;
  text-align: left;
}

.contact-info h3,
.legal-links h3,
.social-icons h3 {
  margin-bottom: 1rem;
  color: white;
}

.contact a {
  color: white;
  text-decoration: none;
  cursor: pointer;
}

.contact a:hover {
  text-decoration: underline;
}

.legal-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.legal-links li {
  margin: 0.3rem 0;
}

.legal-links router-link {
  color: #ccc;
  display: inline-block;
}

.social-icons a {
  margin: 0 0.5rem;
  font-size: 24px;
}

.contact-link i,
.social-icons i {
  color: white;
  margin-right: 8px;
  font-size: 20px;
  transition: color 0.3s ease;
}

.contact-link a:hover i,
.social-icons a:hover i {
  color: #f7c200;
}

.copyright-bar {
  text-align: center;
  margin-top: 2rem;
  font-size: 0.9rem;
  color: #777;
}
.site-author {
  text-align: center;
  font-size: 0.9rem;
  color: #777;
  margin-top: 0.5rem;
}

.site-author a {
  color: #f7c200;
  text-decoration: none;
}

.site-author a:hover {
  text-decoration: underline;
}
</style>
